import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';

import SubMenuLeftColumn from 'components/navV2/navPrimarySubMenu/SubMenuLeftColumn';
import NavMarketingModules from 'components/navV2/navPrimarySubMenu/NavMarketingModules';

import rmvSpaceAndSpecial from 'util/rmvSpaceAndSpecial';
import { primaryNavItemToBusinessUnitMap } from 'components/navV2/navPrimarySubMenu/helpers/mapPrimaryNavItemToBusinessUnit';

import TwoRowColContainer from './TwoRowColContainer';
import SingleRowColContainer from './SingleRowColContainer';

import css from '../subMenu.module.less';
import regColCSS from '../../SubMenuColumn/subMenuColumn.module.less';

const {
  PRIMARY: { REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS },
} = NAV_DATA;

const NavPrimaryRegistrySubMenu = ({ data, activeNavType, isLoggedIn }) => {
  const shouldRenderLeft = data.callToAction || data.userActionsLinks;

  const containerClass = cx(
    css.columnContainer,
    css[`columnContainer${rmvSpaceAndSpecial(data.title)}`],
    { [regColCSS.registry]: isLoggedIn }
  );

  const businessUnit = primaryNavItemToBusinessUnitMap[data.id];

  const renderColumns = () => {
    if (isLoggedIn) return <TwoRowColContainer data={data} className={containerClass} />;
    return <SingleRowColContainer data={data} className={containerClass} />;
  };

  return (
    <Fragment>
      {shouldRenderLeft && (
        <SubMenuLeftColumn
          cta={data.callToAction}
          title={data.title}
          businessUnit={businessUnit}
          activeNavType={activeNavType}
        />
      )}
      {renderColumns()}
      <NavMarketingModules activeNavType={activeNavType} businessUnit={businessUnit} />
    </Fragment>
  );
};

NavPrimaryRegistrySubMenu.propTypes = {
  data: PropTypes.shape({
    callToAction: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.string),
    }),
    userActionsLinks: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
        title: PropTypes.string,
      })
    ),
    title: PropTypes.string,
    id: PropTypes.oneOf([REGISTRY, WEBSITE, PAPER, GUEST_LIST, WEDDING_BOUTIQUE, VENDORS]),
    isActive: PropTypes.bool,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.string,
        borderLeft: PropTypes.bool,
        children: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
          })
        ),
      })
    ).isRequired,
  }),
  activeNavType: PropTypes.string,
  isLoggedIn: PropTypes.bool,
};

export default NavPrimaryRegistrySubMenu;
